import { KuxFilteredCategoriesDTO, UIDAPresentationTypeEnum, UIDAStructureTypeEnum } from '@kaltura-ott/tvpil';
import { observable } from 'mobx';
import { container } from 'tsyringe';

import type { ParentalPinStore } from '../../parentalPin/parental-pin-store';
import { CategoryChildren } from '../category-children';
import { CategoryStore } from '../category-store';

/**
 * @category Store
 */
export class SubpageStore extends CategoryStore<CategoryChildren> {
  type: UIDAStructureTypeEnum.subpage = UIDAStructureTypeEnum.subpage;
  subpageProperty: KuxFilteredCategoriesDTO['subpageProperty'];

  @observable image = '';

  init() {
    const parentalPinStore = container.resolve<ParentalPinStore>('parentalPinStore');
    parentalPinStore.setLastPageLink(
      this.subtype !== UIDAPresentationTypeEnum.parental_control ? '' : this.referenceId,
    );
  }

  // TODO NTD https://kaltura.atlassian.net/wiki/spaces/KUXDEV/pages/1728414630/Deep+Link
  link: string;
  constructor(props: KuxFilteredCategoriesDTO, categoryTree: KuxFilteredCategoriesDTO, children: [] = []) {
    super(props, categoryTree);
    this.children = children;
    this.subpageProperty = props.subpageProperty;
    this.link = `/subpage/${this.id}`;
    if (props.images.length > 0) {
      this.image =
        props.images?.find(({ imageTypeId }) => imageTypeId === props.railImageProperty?.assetPresentationImageType)
          ?.url || props.images[0]?.url;
    }
  }
}
